import { ALL_LEAGUE_MODES, LeagueMode } from "../../pages/createLeague/modeContent";

export { ALL_LEAGUE_MODES };
export type { LeagueMode };

/**
 * Short display label per mode, for the admin UI. Plain strings, not t() — matches
 * today's admin screens (ConfigTab.tsx, AdminCompetitionPage.tsx), which don't go
 * through i18n for this yet; that adoption is tracked separately, not here.
 *
 * What this actually fixes is drift: ConfigTab.tsx and AdminCompetitionPage.tsx each
 * used to declare their own copy of this list by hand, so a mode added to
 * ALL_LEAGUE_MODES could silently be missing from one of them. `Record<LeagueMode, ...>`
 * makes that a compile error instead.
 */
export const COMPETITION_MODE_LABELS: Record<LeagueMode, string> = {
  TARGET: "Target",
  GAMEWEEK_CHALLENGE: "GW Challenge",
  FINAL_POSITIONS: "Final Positions",
  SCORE_PREDICTOR: "Predict the Score",
  SYNDICATE: "Syndicate",
};

export function competitionModeLabel(mode: string): string {
  return (COMPETITION_MODE_LABELS as Record<string, string>)[mode]
    ?? mode.charAt(0) + mode.slice(1).toLowerCase();
}

/** `{ key, label }[]` shape for direct use in `.map()` over checkbox/select lists. */
export const COMPETITION_MODES: { key: LeagueMode; label: string }[] =
  ALL_LEAGUE_MODES.map((key) => ({ key, label: COMPETITION_MODE_LABELS[key] }));
